//系统识别
function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
if(system_confirm()=="mac"){var isMac=true}
else if(system_confirm()=="win"){var isMac=false}
if(device_confirm()==true){var device_id=true}
else if(device_confirm()==false){var device_id=false}else{};
function system_fn(){
    if (isMac == true) {
      $('.mac_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
      $('.mac_btn').css({"display":"block"});
      $('.mac_inline').css({"display":"inline-block"});
      $('.win_inline').css({"display":"none"});
      $('.win_btn_box').css({"display":"none"});
      $('.win_btn').css({"display":"none"});
      $(".mac_text").css('display','block');
      $(".win_text").css('display','none');
      $('.version_win').css({"display":"none"});
      $('.version_mac').css({"display":"block"});
    } else if (!isMac == true) {
      $('.win_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
      $('.win_btn').css({"display":"block"});
      $('.mac_inline').css({"display":"none"});
      $('.win_inline').css({"display":"inline-block"});
      $(".mac_text").css('display','none');
      $(".win_text").css('display','block');
      $('.mac_btn_box').css({"display":"none"});
      $('.mac_btn').css({"display":"none"});
      $('.version_win').css({"display":"block"});
      $('.version_mac').css({"display":"none"});
      
    } else if (device_id == false) {
      $('.pc_btn').css({"display":"none"});
      $('.version_win').css({"display":"block"});
      $('.version_mac').css({"display":"none"});
      $('.mac_inline').css({"display":"none"});
      $('.win_inline').css({"display":"inline-block"});
    };
};
system_fn();

//1. bd-dvd-ripper
$("[pid='bd-dvd-ripper_win']").addClass("down-bd-ripper-win");
$("[pid='bd-dvd-ripper_win']").attr("id","down-bd-ripper-win");
$("[pid='bd-dvd-ripper_mac']").addClass("down-bd-ripper-mac");
$("[pid='bd-dvd-ripper_mac']").attr("id","down-bd-ripper-mac");


//2. dvd ripper
$("[pid='dvd-ripper_win']").addClass("down-dvd-ripper-win");
$("[pid='dvd-ripper_win']").attr("id","down-dvd-ripper-win");
$("[pid='dvd-ripper_mac']").addClass("down-dvd-ripper-mac");
$("[pid='dvd-ripper_mac']").attr("id","down-dvd-ripper-mac");

//3. blu-ray player
$("[pid='blu-ray-player_win']").addClass("down-bd-player-win");
$("[pid='blu-ray-player_win']").attr("id","down-bd-player-win");
$("[pid='blu-ray-player_mac']").addClass("down-bd-player-mac");
$("[pid='blu-ray-player_mac']").attr("id","down-bd-player-mac");


//4.blu-ray copy
$("[pid='blu-ray-copy_win']").addClass("down-bd-copy-win");
$("[pid='blu-ray-copy_win']").attr("id","down-bd-copy-win");
$("[pid='blu-ray-copy_mac']").addClass("down-bd-copy-mac");
$("[pid='blu-ray-copy_mac']").attr("id","down-bd-copy-mac");


//5.dvd creator
$("[pid='dvd-creator_win']").addClass("down-dvd-creator-win");
$("[pid='dvd-creator_win']").attr("id","down-dvd-creator-win");
$("[pid='dvd-creator_mac']").addClass("down-dvd-creator-mac");
$("[pid='dvd-creator_mac']").attr("id","down-dvd-creator-mac");


//6.dvd copy
$("[pid='dvd-copy_win']").addClass("down-dvd-copy-win");
$("[pid='dvd-copy_win']").attr("id","down-dvd-copy-win");
$("[pid='dvd-copy_mac']").addClass("down-dvd-copy-mac");
$("[pid='dvd-copy_mac']").attr("id","down-dvd-copy-mac");

var windowWidth=$(window).width();
$(window).resize(function(){
    if(windowWidth!=$(window).width()){
      $('header .mobile-menu-switch').removeClass('is-active')
      $('header .menu').removeAttr('style')
      $('header .is-more').removeClass('is-active')
      $('header .item-content').removeAttr('style')
      windowWidth=$(window).width()
    }
});

// 上导航
$('header .mobile-menu-switch').click(function(){
  $(this).toggleClass('is-active')
  $('header .menu').slideToggle()
})
$('header .is-more').click(function(){
  $(this).parent().toggleClass('active')
  $(this).next().slideToggle()
  return false;
})
// 下导航
$('.footer .language span').click(function(){
  $(this).toggleClass('active')
  $('.footer .language ul').slideToggle()
});
// 下载
(function(){
  let len = document.getElementsByClassName('download').length;
  let link = "videobyte.org";
  for (let i = 0; i < len; i++) {
      let btn = document.getElementsByClassName('download')[i];
      let language = window.location.pathname.split('/')[1];
      if (language == 'ja' || language == 'de' || language == 'fr') {
          link += `/${languagge}`;
      }
      let link_d = `dl.videobyte.cc`;
      let language_d = window.location.pathname.split('/')[1];

      if (language_d == 'ja' || language_d == 'de' || language_d == 'fr') {
          link_d += `/${language_d}`;
      }
      function download(pid, mywin) {
          const url = mywin == 'mac' ? `https://${link_d}/${pid}.dmg` : `https://${link_d}/${pid}.exe`
          console.log(url)
          window.location.href = url;
      }

      btn.addEventListener('click', function() {
          let str = this.getAttribute('pid');
          let pid = str.split("_")[0];
          let mywin = str.split('_')[1];
          let width = window.screen.width || document.body.clientWidth;
          if (width > 0 && width <= 760) {
              let url = `https://${link}/${pid}/mobile-download/`
              window.open(url);
          } else if (width > 760) {
              download(pid, mywin)
          }

      })
  }
})();
(function(){
  //隐私协议
  var cookie={
    setcookie:function(name,value,Days,path){
      if(typeof(Days)=='undefined'){
        var Days=24;
      }
      if(typeof(path)=='undefined'){
        path='path=/;';
      }else{
        path='';
      }
      var date=new Date(); 
      date.setTime(date.getTime() + Days*1*60*60*1000);
      document.cookie=name+"="+value+";"+path+"expires="+date.toGMTString();
    },
    getcookie:function(name){
      var cookies=document.cookie.split(';'); 
      var cookieValue=0;
      for (var i=0; i < cookies.length; i++){
        var cookie=jQuery.trim(cookies[i]); 
        if(cookie.substring(0, name.length + 1)==(name + '=')){
          cookieValue=decodeURIComponent(cookie.substring(name.length + 1)); 
          break; 
        }
      }
      return cookieValue; 
    }
  }
  if(cookie.getcookie('usernotice_pop')==0){
      $('body').append(`  <div id="prompt-box" class="prompt-box" style="display: flex;">
    <div class="prompt-box-text">
      We use cookies to ensure that you get the best experience on our website. Clicking "Accept Cookies"  means you agree with our <a href="/privacy-policy/" style="color: #43CA9A;">Privacy Policy</a>.
      
    </div>
    <button id="agree-button" style="background-color: #43CA9A;">Accept Cookies</button>
  </div>`);
    $('#agree-button').click(function(){
          $(this).parent().hide()
      cookie.setcookie('usernotice_pop','in');
    })
  }
})();

// back-to-top
(function () {
  $(window).scroll(function () {
    if ($(document).scrollTop() >= 500) {
      $(".back-to-top").addClass('is-active');
      $(".back-to-top").show();
      $(".back-to-top").click(function () {
        $("body,html").scrollTop(0);
      });
    } else {
      $(".back-to-top").hide();
    }
  });
})();
$('.body_special').on('click',function(e){
  e.stopPropagation();
})
$(document).on('click',function(){
  $('.body_special').hide();
})